import '../css/homepage.css';
import Navbar from './Navbar.jsx';

function Homepage(props) {


    return (
        <div className="homepage">
            <div className="overlay">
                <Navbar currentComponent={props.currentComponent} setCurrentComponent={props.setCurrentComponent} />
                <div className="homepage-container">
                    <h1>Full Interior Designs.</h1>
                    <h1>Start to Finish.</h1>
                    <h1>Passion, Creativity, and Quality in <span>Between</span>.</h1>
                    <div className="homepage-buttons">
                        <p onClick={() => props.setCurrentComponent('portfolio')}>View work</p>
                        <p onClick={() => props.setCurrentComponent('contact')}>Contact</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Homepage;
